import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import Swal from 'sweetalert2';

const AddScore = ({ show, onClose, onUnitCreated }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [selectedOption, setSelectedOption] = useState([]);
    const [unitCatOptions, setUnitCatOptions] = useState([]);
    const [score, setScore] = useState('');
    const [score_name, setScoreName] = useState(''); 
    const [description, setDescription] = useState(''); 
    const [loading, setLoading] = useState(false);
 
    //  useEffect(() => {
    //     axios.get(`${baseURL}/unitcategory/category/active`)
    //         .then(res => {
    //             const options = res.data.data.map(cat => ({
    //                 value: cat.unitcategory_id,
    //                 label: cat.unitcategory_name
    //             }));
    //             // Add "All" option at the top
    //             setUnitCatOptions([{ value: 'all', label: 'All' }, ...options]);
    //         })
    //         .catch(err => {
    //             console.error('Failed to fetch unit categories:', err);
    //         });
    // }, []);

    // const handleCategoryChange = (selected) => {
    //     // If "All" is selected, select all except "All"
    //     if (selected && selected.find(opt => opt.value === 'all')) {
    //         const allWithoutAll = unitCatOptions.filter(opt => opt.value !== 'all');
    //         setSelectedOption(allWithoutAll);
    //     } else {
    //         setSelectedOption(selected);
    //     }
    // };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        

        if (!score) {
            newErrors.score = "This Field is Required.";
        }

        if (!score_name) {
            newErrors.score_name = "This Field is Required.";
        }

        return newErrors;
    };

    // Handle form submission
    const handleSubmit = async (event) => {
        
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        
        // const unit_category_snos = selectedOption.map(option => option.value);

        // if (!unitName || unit_category_snos.length === 0) {
        //     // Swal.fire("Validation Error", "Please fill all required fields.", "warning");
        //     return;
        // } 

        const payload = {
            score: score,
            score_name: score_name || null,
            description,
            // unit_category_snos,
        };

        try {
            setLoading(true);
            const res = await axios.post(`${baseURL}/score`, payload);
            // Swal.fire("Success", res.data.message, "success");
            onClose();
            setScore('');
            setScoreName('');
            setDescription('');
            // setSelectedOption([]);
            if (onUnitCreated) onUnitCreated(); // Trigger parent to refresh unit list
            window.location.reload();
        } catch (err) {
            const message = err.response?.data?.message || 'Something went wrong';
            const errors = err.response?.data?.errors;
            if (errors) {
                const errorList = Object.values(errors).flat().join('<br>');
                // Swal.fire("Validation Error", errorList, "error");
            } else {
                // Swal.fire("Error", message, "error");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#dcf1dc' }}>
                    <h3 className="modal-title">Create Units</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Score<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Score"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                            />
                            {errors.score && <div className="text-danger fs-8 mt-1">{errors.score}</div>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Score Name<span className="required">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Score Name"
                                value={score_name}
                                onChange={(e) => setScoreName(e.target.value)}
                            />
                            {errors.score_name && <div className="text-danger fs-8 mt-1">{errors.score_name}</div>}
                        </div>
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Unit Category<span className="required">*</span></label>
                            <Select
                                placeholder='Select Unit Category'
                                isMulti
                                value={selectedOption}
                                onChange={handleCategoryChange}
                                options={unitCatOptions}
                            />
                        </div> */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={8}
                                className="form-control"
                                name="comment"
                                placeholder="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Button
                            className="btn btn-sm btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? <Spinner animation="border" size="sm" /> : 'Create Score'}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddScore;
